import { CHANGE_IS_MOBILE } from '../actionTypes';

export default (state = 0, action) => {
  if (action.type === CHANGE_IS_MOBILE) return action.payload;
  return state;
}
